export default __webpack_public_path__ + "company_data_intro_splash.png";